exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-226bfecc] {\n  padding: 1.6rem 0.53rem;\n}\n.box h4[data-v-226bfecc] {\n  margin-top: 0.43rem;\n  margin-bottom: 1.6rem;\n}\n.box .smsBtn[data-v-226bfecc] {\n  width: 2.56rem;\n  height: 1.17rem;\n  border-radius: 0.21rem;\n  border: 0.04rem solid #3667EC;\n  margin-left: 0.53rem;\n}\n.box .countBtn[data-v-226bfecc] {\n  background: #ffffff;\n}\n.box .countBtn span[data-v-226bfecc] {\n  color: #3667EC;\n  font-weight: bold;\n}\n.box .resendBtn[data-v-226bfecc] {\n  background: #3667EC;\n}\n.box .resendBtn span[data-v-226bfecc] {\n  color: #fff;\n  font-weight: bold;\n}\n", ""]);

// exports
